export const ultra_2 = {
    'images': [],
    'mainFeatures': [
        'Nano Graphite Coating with Premium Nature Rubber.',
        'Patented Multi-functional Mounting Base & Adapters.',
    ],
    'material': [
        'Rubber: Premium Nature Rubber.',
        'Steel: SGCC, Electrostatic Powder Coating.',
        'Plastic: Spacer & Adapter: POM',
        'Stainless Steel Backing: SUS304ES',
    ],
    'featureIcons': ["02", "03", "08", "10"],
    'otherFeatures': ["01", "02"],
    'specification': [
        { "inch": "10", "mm": "250", "claw": "4", "width": "6", "thickness": "0.8" },
        { "inch": "11", "mm": "280", "claw": "4", "width": "6", "thickness": "0.8" },
        { "inch": "12", "mm": "300", "claw": "4", "width": "6", "thickness": "0.8" },
        { "inch": "14", "mm": "350", "claw": "4", "width": "6", "thickness": "0.8" },
        { "inch": "15", "mm": "375", "claw": "4", "width": "6", "thickness": "0.8" },
        { "inch": "16", "mm": "400", "claw": "4", "width": "6", "thickness": "0.8" }
    ],
    'adapters': ["r1", "r2", "r3", "r4"]
}